import React from 'react';
import { type WhiteboardSidePanelItem } from '../sidepanel-types';
import SidePanelContent from './SidePanelContent';
import SidePanelHeader from './SidePanelHeader';
import SidePanelTab from './SidePanelTab';
import SidePanelTitle from './SidePanelTitle';
import framesIcon from '../assets/icons/frames.svg';
import { svgToIcon } from '../utils/svg';

export const presentationSidePanelItems: WhiteboardSidePanelItem[] = [
  {
    id: 'frames',
    name: 'Frames',
    icon: svgToIcon(framesIcon),
    tabContent: <SidePanelTab />,
    content: <SidePanelContent />,
    titleContent: <SidePanelTitle />,
    headerContent: <SidePanelHeader />,
    hidden: ({ canPresent }) => !canPresent,

    // this is important because we listen to frame changes only while the content is visible.
    // For performance reasons, we don't want that to happen while it's hidden
    alwaysRendered: false,
  },
];
